import React, {Fragment, useState} from 'react';
import {Link, NavLink} from "react-router-dom";
import {Can} from "../../../../ability-context";
import createLink from "../../../../libs/createLink";
//import {logoutUser} from "../../../../reducers2/login";
//import {markAllUserNotificationsOpen} from "../../../../creators/user.notifications";
//import {fetchUnreadNotifications} from "../../../../creators/user.unreadNotification";
//import {fetchUnreadRooms} from "../../../../creators/user.unreadRooms";
import Icon from "../../Icon";
import Dropdown from "../../Dropdown";
import NotificationsList from "../../notifications/components/NotificationsList";
import Avatar from "../../Avatar";
import Modal from "../../Modal";
import Upload from "../../upload/Uploads";
import ModalSubscription from "../../ModalSubscription";
import _ from "lodash";
import CtaCannot from "../../CtaCannot";
import FakeNotifications from "./FakeNotifications";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

import {
    fetchUnreadRooms,
    USER_CURRENT_KEY,
    USER_UNREAD_ROOMS_KEY,
    USER_UNREAD_NOTIFICATIONS_KEY,
    fetchUnreadNotifications,
    USER_FRIENDS_KEY,
    fetchUserFriends,
    USER_NOTIFICATIONS_KEY
} from "../../../../api/public-voissa/users";
import Logout from "../../Logout";
import {useSocketFriends, useSocketNotifications, useSocketRooms} from "../../../../hooks/useSocket";



const NavbarConnect = ({
           showSearchBar = false
    }) =>{

    const [toggleChildren, setToggleChildren] = useState(false);
    const [toggleNotif, setToggleNotif] = useState(false);
    const [toggleUpload, setToggleUpload] = useState(false);
    const [toggleSubscription, setToggleSubscription] = useState(false);
    const [isLogout, setIsLogout] = useState(false);

    const queryClient = useQueryClient();

    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const isCurrentUser = !!_.get(dataCurrentUser, '_id');

    const {data : dataUnReadRoom} = useQuery(
        [USER_UNREAD_ROOMS_KEY],
        ()=> fetchUnreadRooms(),
        {
            staleTime : (1000 * 60 * 2),
            enabled : isCurrentUser,
            placeholderData : {total : 0}
        }
    );


    const {data : dataUnReadNotifications} = useQuery(
        [USER_UNREAD_NOTIFICATIONS_KEY],
        ()=> fetchUnreadNotifications(),
        {
            staleTime : (1000 * 60 * 2),
            enabled : isCurrentUser,
            placeholderData : {total : 0}
        }
    );

    useQuery(
        [USER_FRIENDS_KEY, _.get(dataCurrentUser,'_id'), {limit: false}],
        ()=> fetchUserFriends(_.get(dataCurrentUser,'_id'), {limit: false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : isCurrentUser,
            placeholderData : {
                data : [],
                total : 0
            },
            select : (data) =>{
                return {
                    friends : data.data || [],
                    total : data.total
                }
            }
        }
    );

    const {
        mutate : mutateReadAllNotification,
    } = useMutation(() => fetchUnreadNotifications(),{
        onSuccess: (data) =>{
            const queryCache = queryClient.getQueryCache()
            const queryKeys = queryCache.getAll().map(cache => cache.queryKey).filter(cache => cache[0] === USER_NOTIFICATIONS_KEY);

            queryKeys.forEach(queryKey =>{
                const previousValue = queryClient.getQueryData(queryKey);
                if(previousValue){
                    const newPagesArray = previousValue?.pages.map((page) => {
                            page.data = page.data.map((item) => {
                                item = {...item, open : true};
                                return item;
                            });
                            return page;
                        }
                    ) ?? []

                    queryClient.setQueryData(queryKey, oldData => ({
                        pages: newPagesArray,
                        pageParams: oldData.pageParams,
                    }));
                }
            });
        }
    });


    useSocketRooms();
    useSocketFriends();
    useSocketNotifications();


    if(isLogout){
        //todo: revoir ca avec max :)
        return <Logout />
    }


    return isCurrentUser ? (
        <Fragment>
            {!showSearchBar && (
                <div className="navbar-user-options">
                    <Can action={"chat-webcam"} subject="all" passThrough>
                        {can => {
                            return can ? (
                                <Link className={"access-messenger"} to={createLink("chatWebcam")}>
                                    <Icon type={"chat-webcam"} className={"icon-chat"} />
                                </Link>
                            ) : (
                                <CtaCannot
                                    action={"chatWebcam"}
                                    isModal={true}
                                >
                                    <div className={"access-messenger cursor-pointer"}> <Icon type={"chat-webcam"} className={"icon-chat"} /></div>
                                </CtaCannot>
                            )
                        }}
                    </Can>
                    <Can action={"read"} subject="Room">
                        <Link className={"access-messenger"} to={createLink("messenger")}>
                            <Icon type={"speech-bubbles"}/>
                            {dataUnReadRoom.total > 0 && <div
                                className="notifications-count">{dataUnReadRoom.total > 99 ? '99+' : dataUnReadRoom.total}</div>}
                        </Link>
                    </Can>
                    <Can action={"read"} subject="Notification">
                        <Dropdown className="notification-dropdown" align="right"
                                  handleToggleChildren={(value) => setToggleNotif(value)}
                            // toggle={true}
                                  toggleStatus={toggleNotif}
                                  activableComponent={(
                                      <div className="notifications">
                                          <Icon type="bell"/>
                                          {dataUnReadNotifications.total > 0 && <div
                                              className="notifications-count">{dataUnReadNotifications.total > 99 ? '99+' : dataUnReadNotifications.total}</div>}
                                      </div>
                                  )}>
                            <div className="topline-notification-dropdown">
                                <div className="title">Notifications</div>
                                <div className="options-dropdown">
                                    <div className="read-all"
                                         onClick={() => mutateReadAllNotification()}
                                        >Tout marquer comme lu
                                    </div>
                                    -
                                    <NavLink to={createLink("userMeSettingsOptionsNotifications")}>
                                        <div className="settings"
                                             onClick={() => setToggleNotif(false)}>Paramètres
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                            <NotificationsList
                                handleCloseDropdown={() => setToggleNotif(false)}/>
                        </Dropdown>
                    </Can>
                    <Dropdown align="right" handleToggleChildren={(value) => setToggleChildren(value)}
                              toggleStatus={toggleChildren} activableComponent={(
                        <Avatar
                            avatar={_.get(dataCurrentUser, 'profile.avatar')}
                            gender={_.get(dataCurrentUser, 'profile.gender')}/>
                    )}>
                        <ul className="dropdown-menu">
                            <ul className="messenger-dropdown-style">
                                <Can action={"upload"} subject="Media">
                                    <li className="menu-item"
                                        onClick={() => {setToggleUpload(true); setToggleChildren(false)}}
                                    >
                                        <Icon type="arrow-up"/> Envoyer une photo / vidéo
                                    </li>
                                </Can>
                                {/*todo: replace currentUser*/}
                                {/*!_.get(dataCurrentUser, 'customer.subscribed') && (
                                    <li className="menu-item"
                                        onClick={() => onClickModalSubscription()}
                                    >
                                        <Icon type="star-empty"/> Devenir VIP
                                    </li>
                                )*/}
                                {isCurrentUser && !_.get(dataCurrentUser, 'customer.subscribed') ?
                                    <CtaCannot action={"subscription"} isModal={true}>
                                        <li className="menu-item">
                                            <Icon type="star-empty"/> Devenir VIP
                                        </li>
                                    </CtaCannot>
                                    : null}
                                {isCurrentUser && !dataCurrentUser.isCertified && dataCurrentUser.profile.gender !== 1 && (
                                    <NavLink
                                        to={createLink('userMeSettingsAbonnement', dataCurrentUser)}
                                        className="menu-item"
                                        onClick={() => setToggleChildren(false)}
                                    ><Icon
                                        type="star-empty"/> Certifier mon compte</NavLink>
                                )}

                                <NavLink to={createLink('userMe', dataCurrentUser)}
                                         className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                >
                                    <Icon
                                    type="user-o"/> Mon profil</NavLink>
                                <NavLink to={createLink('userMeAlbums', dataCurrentUser)}
                                         className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                ><Icon
                                    type="picture"/> Mes albums</NavLink>
                                <NavLink to={createLink('userMeArticles', dataCurrentUser)}
                                         className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                ><Icon
                                    type="article"/>Mes articles</NavLink>
                                <NavLink to={createLink('userMeFriends', dataCurrentUser)} className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                         rel={"nofollow"}><Icon
                                    type="group"/>Mes amis</NavLink>
                                <NavLink to={createLink('userMeSettings', dataCurrentUser)} className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                ><Icon
                                    type="cog"/> Paramètres</NavLink>
                                {/*<NavLink to={createLink('commentsModeration')}
                                         className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                ><Icon
                                    type="report"/> Modération commentaires</NavLink>*/}

                            </ul>
                            {
                                //todo : revoir le right
                            }
                            <Can action={"moderation"} subject="Reporting">
                                <ul className="messenger-dropdown-style">
                                    <NavLink to={createLink("pcModerator")} className="menu-item"
                                             onClick={() => setToggleChildren(false)}
                                    ><Icon
                                        type="report"/> PC Modérateur</NavLink>
                                </ul>
                            </Can>

                            <ul className="messenger-dropdown-style">
                                <NavLink to={createLink("tagModerationQualifications")} className="menu-item"
                                         onClick={() => setToggleChildren(false)}
                                ><Icon
                                    type="report"/> Médias à catégoriser</NavLink>
                            </ul>

                            <Can action={"verification"} subject="TagModeration">
                                <ul className="messenger-dropdown-style">
                                    <NavLink to={createLink("tagModerationVerifications")} className="menu-item"
                                             onClick={() => setToggleChildren(false)}
                                    ><Icon
                                        type="report"/> Médias à vérifier</NavLink>
                                </ul>
                            </Can>

                            <Can action={"treatmentVideo"} subject="TagModeration">
                                <ul className="messenger-dropdown-style">
                                    <NavLink to={createLink("tagModerationTreatmentVideo")} className="menu-item"
                                             onClick={() => setToggleChildren(false)}
                                    ><Icon
                                        type="report"/>Gestion de la timeline des vidéos</NavLink>
                                </ul>
                            </Can>

                            <ul className="messenger-dropdown-style">
                                <li className="menu-item logout"
                                    onClick={() => setIsLogout(true)}
                                ><Icon
                                    type="sign-out"/> Me déconnecter
                                </li>
                            </ul>
                        </ul>
                    </Dropdown>
                </div>
            )}
            <Modal toggle={toggleUpload}
                   handleClose={() => setToggleUpload(false)}>
                <Upload handleClose={() => setToggleUpload(false)}/>
            </Modal>
            <Modal toggle={toggleSubscription}
                   handleClose={() => setToggleSubscription(false)}>
                <ModalSubscription handleClose={() => setToggleSubscription(false)} />
            </Modal>
        </Fragment>
    ) : !isCurrentUser && (

        !showSearchBar && (
            <Fragment>
                <div className="navbar-user-options">
                    <FakeNotifications
                        //gotoMessenger={this.gotoMessenger}
                        toggleNotif={toggleNotif}
                        //handleToggleNotification={handleToggleNotification}
                        handleCloseDropdown={()=>setToggleNotif(!toggleNotif)}
                    />
                </div>
                <div className="navbar-not-logged">
                    <Link to={createLink("signin")} rel={"nofollow"}><span>Accès membres</span></Link>
                </div>
            </Fragment>
        )
    )
}

export default NavbarConnect;